module.exports = __webpack_public_path__ + "stu-res/img/k-01@3x.35de63a0.png";